import { createAction, props } from '@ngrx/store';
import { GetMetricStatisticInput } from '@smash-sdk/transfer/ejs/01-2024';

// Account
export const loadAccountTransferCount = createAction(
  '[Admin Dashboard] Load Account Transfer Count',
  props<{ period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadAccountTransferCountSuccess = createAction(
  '[Admin Dashboard] Load Account Transfer Count Success',
  props<{ transferCountSeries: any[] }>()
);

export const loadAccountTransferCountFailure = createAction(
  '[Admin Dashboard] Load Account Transfer Count Failure',
  props<{ error: any }>()
);

export const loadAccountSizeCount = createAction(
  '[Admin Dashboard] Load Account Size Count',
  props<{ period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadAccountSizeCountSuccess = createAction(
  '[Admin Dashboard] Load Account Size Count Success',
  props<{ sizeCountSeries: any[] }>()
);

export const loadAccountSizeCountFailure = createAction(
  '[Admin Dashboard] Load Account Size Count Failure',
  props<{ error: any }>()
);

export const loadAccountFileCount = createAction(
  '[Admin Dashboard] Load Account File Count',
  props<{ period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadAccountFileCountSuccess = createAction(
  '[Admin Dashboard] Load Account File Count Success',
  props<{ fileCountSeries: any[] }>()
);

export const loadAccountFileCountFailure = createAction(
  '[Admin Dashboard] Load Account File Count Failure',
  props<{ error: any }>()
);

export const loadAccountActiveUsersCount = createAction(
  '[Admin Dashboard] Load Account Active Users Count',
  props<{ period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadAccountActiveUsersCountSuccess = createAction(
  '[Admin Dashboard] Load Account Active Users Count Success',
  props<{ activeUsersCountSeries: any[] }>()
);

export const loadAccountActiveUsersCountFailure = createAction(
  '[Admin Dashboard] Load Account Active Users Count Failure',
  props<{ error: any }>()
);

export const loadAccountActiveGuestsCount = createAction(
  '[Admin Dashboard] Load Account Active Guests Count',
  props<{ period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadAccountActiveGuestsCountSuccess = createAction(
  '[Admin Dashboard] Load Account Active Guests Count Success',
  props<{ activeGuestsCountSeries: any[] }>()
);

export const loadAccountActiveGuestsCountFailure = createAction(
  '[Admin Dashboard] Load Account Active Guests Count Failure',
  props<{ error: any }>()
);

export const loadAccountTotalActiveUsersCount = createAction(
  '[Admin Dashboard] Load Account Total Active Users Count',
  props<{ period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadAccountTotalActiveUsersCountSuccess = createAction(
  '[Admin Dashboard] Load Account Total Active Users Count Success',
  props<{ totalActiveUsersCountSeries: any[] }>()
);

export const loadAccountTotalActiveUsersCountFailure = createAction(
  '[Admin Dashboard] Load Account Total Active Users Count Failure',
  props<{ error: any }>()
);

// Team
export const loadTeamTransferCount = createAction(
  '[Admin Dashboard] Load Team Transfer Count',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTeamTransferCountSuccess = createAction(
  '[Admin Dashboard] Load Team Transfer Count Success',
  props<{ transferCountSeries: any[] }>()
);

export const loadTeamTransferCountFailure = createAction(
  '[Admin Dashboard] Load Team Transfer Count Failure',
  props<{ error: any }>()
);

export const loadTeamSizeCount = createAction(
  '[Admin Dashboard] Load Team Size Count',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTeamSizeCountSuccess = createAction(
  '[Admin Dashboard] Load Team Size Count Success',
  props<{ sizeCountSeries: any[] }>()
);

export const loadTeamSizeCountFailure = createAction(
  '[Admin Dashboard] Load Team Size Count Failure',
  props<{ error: any }>()
);

export const loadTeamFileCount = createAction(
  '[Admin Dashboard] Load Team File Count',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTeamFileCountSuccess = createAction(
  '[Admin Dashboard] Load Team File Count Success',
  props<{ fileCountSeries: any[] }>()
);

export const loadTeamFileCountFailure = createAction(
  '[Admin Dashboard] Load Team File Count Failure',
  props<{ error: any }>()
);

export const loadTeamActiveUsersCount = createAction(
  '[Admin Dashboard] Load Team Active Users Count',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTeamActiveUsersCountSuccess = createAction(
  '[Admin Dashboard] Load Team Active Users Count Success',
  props<{ activeUsersCountSeries: any[] }>()
);

export const loadTeamActiveUsersCountFailure = createAction(
  '[Admin Dashboard] Load Team Active Users Count Failure',
  props<{ error: any }>()
);

export const loadTeamActiveGuestsCount = createAction(
  '[Admin Dashboard] Load Team Active Guests Count',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTeamActiveGuestsCountSuccess = createAction(
  '[Admin Dashboard] Load Team Active Guests Count Success',
  props<{ activeGuestsCountSeries: any[] }>()
);

export const loadTeamActiveGuestsCountFailure = createAction(
  '[Admin Dashboard] Load Team Active Guests Count Failure',
  props<{ error: any }>()
);

export const loadTeamTotalActiveUsersCount = createAction(
  '[Admin Dashboard] Load Team Total Active Users Count',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTeamTotalActiveUsersCountSuccess = createAction(
  '[Admin Dashboard] Load Team Total Active Users Count Success',
  props<{ totalActiveUsersCountSeries: any[] }>()
);

export const loadTeamTotalActiveUsersCountFailure = createAction(
  '[Admin Dashboard] Load Team Total Active Users Count Failure',
  props<{ error: any }>()
);

// Counters
export const loadFileCounter = createAction(
  '[Admin Dashboard] Load File Counter',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadFileCounterSuccess = createAction(
  '[Admin Dashboard] Load File Counter Success',
  props<{ fileCounter: any }>()
);

export const loadFileCounterFailure = createAction(
  '[Admin Dashboard] Load File Counter Failure',
  props<{ error: any }>()
);

export const loadSizeCounter = createAction(
  '[Admin Dashboard] Load Size Counter',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadSizeCounterSuccess = createAction(
  '[Admin Dashboard] Load Size Counter Success',
  props<{ sizeCounter: any }>()
);

export const loadSizeCounterFailure = createAction(
  '[Admin Dashboard] Load Size Counter Failure',
  props<{ error: any }>()
);

export const loadTransferCounter = createAction(
  '[Admin Dashboard] Load Transfer Counter',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTransferCounterSuccess = createAction(
  '[Admin Dashboard] Load Transfer Counter Success',
  props<{ transferCounter: any }>()
);

export const loadTransferCounterFailure = createAction(
  '[Admin Dashboard] Load Transfer Counter Failure',
  props<{ error: any }>()
);

export const loadTotalActiveUsersCounter = createAction(
  '[Admin Dashboard] Load Total Active Users Counter',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadTotalActiveUsersCounterSuccess = createAction(
  '[Admin Dashboard] Load Total Active Users Counter Success',
  props<{ totalActiveUsersCounter: any }>()
);

export const loadTotalActiveUsersCounterFailure = createAction(
  '[Admin Dashboard] Load Total Active Users Counter Failure',
  props<{ error: any }>()
);

export const loadActiveUsersCounter = createAction(
  '[Admin Dashboard] Load Active Users Counter',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadActiveUsersCounterSuccess = createAction(
  '[Admin Dashboard] Load Active Users Counter Success',
  props<{ activeUsersCounter: any }>()
);

export const loadActiveUsersCounterFailure = createAction(
  '[Admin Dashboard] Load Active Users Counter Failure',
  props<{ error: any }>()
);

export const loadActiveGuestsCounter = createAction(
  '[Admin Dashboard] Load Active Guests Counter',
  props<{ team: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadActiveGuestsCounterSuccess = createAction(
  '[Admin Dashboard] Load Active Guests Counter Success',
  props<{ activeGuestsCounter: any }>()
);

export const loadActiveGuestsCounterFailure = createAction(
  '[Admin Dashboard] Load Active Guests Counter Failure',
  props<{ error: any }>()
);